<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="ID" width="80" align="center">
				  <template slot-scope="scope">
					{{ scope.row.id }}
				  </template>
				</el-table-column>
				<el-table-column label="属性名称" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="属性值" align="center">
				  <template slot-scope="scope">
					{{ scope.row.value | line }}
				  </template>
				</el-table-column>
				<el-table-column label="排序" align="center">
				  <template slot-scope="{row, $index}">
					<div @click.stop="{{changeState($index,'sort','editSortInput')}}">
					<el-input
					  v-if="editable[$index]"
					  v-model="row.sort"
					  size="mini"
					  class="editSortInput"
					></el-input>
					<span v-else>{{row.sort}}</span>
					</div>
				  </template>
				</el-table-column>
				<el-table-column label="门店" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.store_name }}
				  </template>
				</el-table-column>
				<el-table-column label="操作" align="center">
				  <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip>
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 编辑-->
		<el-dialog :visible.sync="open" width="600px" :close-on-click-modal="false" append-to-body :title="title">
		  <el-form ref="form" :model="form" :rules="rules" label-width="80px" size="small">
		    <el-form-item label="属性名称" prop="name">
		      <el-input v-model="form.name" placeholder="请输入属性名称" type="text" clearable />
		    </el-form-item>
			<el-form-item label="属性值" v-for="(item,index) in form.value" :key="index">
				<div class="flex align-center">
					<el-input v-model="form.value[index]" placeholder="请输入属性值" size="medium"></el-input>
					<el-button type="danger font" @click="addSpec" v-if="index === 0" style="margin-left: 10px;">
						<i class="el-icon-plus"></i>
					</el-button>
					<el-button type="danger font" @click="delSpec" v-else style="margin-left: 10px;">
						<i class="el-icon-minus"></i>
					</el-button>
				</div>
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="cancel">取 消</el-button>
		    <el-button type="primary" size="mini" @click="handleSubmit">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'goods_spec',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
					store_id:this.VueCookies.get('store_id')
				},
				form:{
					name:'',
					sort:100,
					value:[''],
					store_id:this.VueCookies.get('store_id')
				},
				rules:{
					name: [
					  { required: true, message: '请输入名称', trigger: 'blur' }
					],
					role_ids: [
					  { required: true, message: '请选择角色', trigger: ['blur', 'change'] }
					],
				},
			}
		},
		mounted() {
			
		},
		methods:{
			reset() {
			  this.form = {
			   name:'',
			   sort:100,
			   value:[''],
			  }
			  this.resetForm('form')
			},
			addSpec(){
				this.form.value.push('')
			},
			delSpec(){
				this.form.value.pop()
			},
		},
		filters:{
			line(item){
				var str = ''
				item.forEach((v)=>{
					str += v+'|'
				})
				str = str.substr(0,str.length-1)
				return str
			},
		},
	}
</script>

<style>
</style>